import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminConsoleDataTable from "../AdminConsoleDataTable";
import fetchData from "../../../../axios/fetchData";
import CustomLoader from "../../../../component/Loader/Loader";
import { users, auditLogsUser } from "../../../../axios/serverUrl";
import { getCustomers } from "../../../../axios/customerApi";

const Users = () => {
  const navigator = useNavigate();
  const [usersTableJson, setUsersTableJson] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.userDetail)?.authority !== "TENANT_ADMIN") {
      return;
    }
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAllUsers = async () => {
    const token = localStorage.getItem("token");
    let page = 0;
    const pageSize = 100;
    let hasNext = true;
    let all = [];

    while (hasNext) {
      const response = await fetchData(
        "GET",
        `${users}?page=${page}&pageSize=${pageSize}&sortProperty=createdTime&sortOrder=DESC`,
        { "X-Authorization": `Bearer ${token}` }
      );

      if (response?.data) {
        all = [...all, ...response.data];
        hasNext = response.hasNext;
        page++;
      } else if (response?.errorCode === 11) {
        navigator("/login");
        localStorage.clear();
        return [];
      } else {
        hasNext = false;
      }
    }
    return all;
  };

  const fetchCustomerMap = async () => {
    const response = await getCustomers();
    if (response?.errorCode === 11) {
      navigator("/login");
      localStorage.clear();
      return {};
    }
    const map = {};
    response?.data?.forEach((c) => {
      map[c.id.id] = c.name;
    });
    return map;
  };

  const fetchLastLogins = async () => {
      const token = localStorage.getItem("token");
      let page = 0;
      let hasNext = true;
      let lastLogins = [];

      while (hasNext) {
          const response = await fetchData(
              "POST",
              `${process.env.REACT_APP_API_URL}/entitiesQuery/find`,
              { "X-Authorization": `Bearer ${token}` },
              `{
              "entityFilter": {
                  "type": "entityType",
                  "entityType": "USER"
              },
              "pageLink": {
                  "pageSize": 10000,
                  "page": ${page},
                  "sortOrder": {
                      "key": { "type": "ATTRIBUTE", "key": "lastlog" },
                      "direction": "DESC"
                  }
              },
              "latestValues": [
                  { "type": "ATTRIBUTE", "key": "lastlog" }
              ],
              "keyFilters": []
          }`
          );

          if (response?.data) {
              lastLogins = [...lastLogins, ...response.data];
              hasNext = response.hasNext;
              page++;
          } else if (response?.errorCode === 11) {
              navigator("/login");
              localStorage.clear();
              return [];
          } else {
              hasNext = false;
          }
      }
      return lastLogins;
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const [allUsers, customerMap] = await Promise.all([
        fetchAllUsers(),
        fetchCustomerMap(),
      ]);
      const customerUsers = allUsers.filter(
        (u) => u.authority === "CUSTOMER_USER"
      );


      const lastLoginsResponse = await fetchLastLogins();
      const lastLogins = Object.fromEntries(
          lastLoginsResponse.map(l => [
            l.entityId.id,
            l.latest.ATTRIBUTE.lastlog?.value
        ])
      );

      const rows = customerUsers.map((u) => {
        return {
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        customer: customerMap[u.customerId?.id] || "",
        lastLogin: Number(lastLogins[u.id.id]),
        thingsboardId: u.id.id,
      }});

      setUsersTableJson(rows);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <AdminConsoleDataTable
        tableHeadings={[
          "First name",
          "Last name",
          "Email",
          "Customer",
          "Last login",
          "Thingsboard ID",
        ]}
        tableJson={usersTableJson}
        type="usersAll"
        defaultSortAsc={false}
        defaultSortFieldId="lastLogin"
      />

      <CustomLoader
        idLoading={isLoading}
        handleLoading={() => setLoading(!isLoading)}
      />
    </div>
  );
};

export default Users;
